import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const adminLegendImagesV2QueryKey = ['adminLegendImagesV2'];

export const useLegendImagesV2 = () => {
  const service = useServices().trackmanParametersV2Service;
  return useQuery({
    queryKey: adminLegendImagesV2QueryKey,
    queryFn: service.getLegendImages,
  });
};
